<template>
  <div id="app">
    <template v-if="loading">
      <LoginBg :pageTitle="$t('login.title')" :isBackGroundOnly=true />
      <v-row
        width="100%"
        class="fill-height ma-0"
        align-center
        justify="center">
        <v-progress-circular
          indeterminate
          color="#FFD600"
          width="6"
          size="64"
        ></v-progress-circular>
      </v-row>
    </template>

    <template v-else>
    <LoginBg :pageTitle="$t('login.title')" :isShowRegister=true />
    <br />
    <v-layout justify-center>
       <!-- <v-form @submit.prevent="submit"></v-form> -->
      <v-form>
        <div class="mb-5" style="width: 300px">
          <v-text-field
            class="text_input inputNumber"
            v-model="username"
            type="number"
            autocomplete="username"
            :label="$t('login.username')"
            :placeholder="$t('login.username')"
            append-icon="phone_iphone"
            filled
            hide-details
            clearable
          ></v-text-field>
        </div>
        <div class="mb-0" style="width: 300px" v-if="login_type == 2">
          <v-text-field
            class="text_input"
            v-model="password"
            :label="$t('login.password')"
            :placeholder="$t('login.password')"
            :append-icon="isShowPassword ? 'visibility' : 'visibility_off'"
            @click:append="isShowPassword = !isShowPassword"
            :type="isShowPassword ? 'text' : 'password'"
            autocomplete="password"
            filled
            hide-details
            clearable
          />
        </div>
        <div class="mb-5" style="width: 300px">
          <v-row v-if="login_type == 1">
            <v-col cols="7">
              <v-text-field
                class="text_input inputNumber"
                v-model="otp"
                type="number"
                autocomplete="otp"
                :label="$t('register.otp_code')"
                :placeholder="$t('register.otp_code')"
                filled
                hide-details
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-btn class="mt-1" color="#1976D2" width="110" height="50" dark @click="requestOtpClick"><div v-html="$t('register.request_otp')"></div></v-btn>
            </v-col>
          </v-row>
        </div>
        <div class="mb-5" style="width: 300px">
          <v-row v-if="login_type == 2">
            <v-col cols="12">
              <div style="margin-top: 8px; text-align: right;">
                <span class="link--text" style="cursor: pointer;" @click="forgotPasswordClick">{{ $t('login.forgotpassword') }}</span>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </v-layout>

    <v-layout justify-center>
      <v-btn rounded color="#3949AB darken-4" width="300" dark @click="loginClick" :disabled="!username || login_type == 1 ? !otp : !password">{{ $t('login.login_button') }}</v-btn>
    </v-layout>
    <br />
    <v-layout justify-center>
      <v-btn rounded :color="login_type == 1 ? '#4CAF50' : '#FFFFFF'" width="300" @click="login_type = 1">{{ $t('login.login_with_otp') }}</v-btn>
    </v-layout>
    <br />
    <v-layout justify-center>
      <v-btn rounded :color="login_type == 2 ? '#4CAF50' : '#FFFFFF'" width="300" @click="login_type = 2">{{ $t('login.login_with_password') }}</v-btn>
    </v-layout>

    </template>

    <ShowOverlay 
      v-model="isShowOverlay">
    </ShowOverlay>
    <ShowMessage 
      v-model="isShowMessage" 
      :msg="showmessage_msg"
      :width="showmessage_width"
      :callBack="showmessage_callback">
    </ShowMessage>

  </div>
</template>

<script>
// import { server } from "@/services/constants";
import LoginBg from "@/components/LoginBg"
import ShowOverlay from "@/components/ShowOverlay"
import ShowMessage from "@/components/ShowMessage"
import api from "@/services/api_villa";
import api2 from "@/services/api";

export default {
  name: "Login",
  data() {
    return {
      username: '',
      password: '',
      isShowPassword: false,
      // remember: false,
      loading: false,

      login_type: 1,

      otp: '',

      isShowOverlay: false,
      isShowMessage: false,
      showmessage_msg: "",
      showmessage_width: 400,
      showmessage_callback: null
    };
  },
  components: {
    LoginBg,
    ShowOverlay,
    ShowMessage
  },
  // async mounted() {
  //   if (this.$store.state.isLogged) {
  //     try {
  //       this.loading = true;
  //       await this.gotoHomePage();
  //     } catch (error) {
  //       this.showMessage(error.toString(), 400);
  //     } finally {
  //       // this.loading = false;
  //     }
  //   }
  // },
  methods: {
    showMessage(showmessage_msg, showmessage_width) {
        this.showmessage_msg = showmessage_msg;
        this.showmessage_width = showmessage_width;
        this.isShowMessage = true;
    },
    onShowMessageCallBack() {
      // this.$router.back();
      this.$store.dispatch("doLogout");
    },
    // async gotoHomePage() {
    //   // this.$router.push(`/home`, () => {});
    //   ///*
    //   // let encryptedText = localStorage.getItem(server.USER_NAME);
    //   // let encryptedText = localStorage.getItem(server.TOKEN_KEY);
    //   // let username = this.$CryptoJS.AES.decrypt(encryptedText, server.TOKEN_PASSWORD).toString(this.CryptoJS.enc.Utf8);
    //   let username = localStorage.getItem(server.TOKEN_KEY);
    //   if (username == null || username.toString().trim()=="") {
    //     this.$store.commit("SET_LOGGED_OUT");
    //     localStorage.removeItem(server.TOKEN_KEY);
    //     localStorage.removeItem(server.ACCEESS_TOKEN);
    //     localStorage.removeItem(server.ACCEESS_EXPIRED);
    //     localStorage.removeItem(server.EXPIRED_SECONDS);
    //     localStorage.removeItem(server.USER_INFO);
    //     this.loading = false;
    //   }
    //   else {
    //     // let userInfo = await api.getUserInfo(username.toString());
    //     // if (userInfo == null) {
    //     //   this.$store.dispatch("doLogout");
    //     // }
    //     // else {
    //     //   localStorage.setItem('userInfo', userInfo);
    //     //   // this.$router.replace('/home');
    //     //   this.$router.push(`/home`, () => {});
    //     // }

    //     await api.refreshUserInfo(username.toString());
    //     // const { redirect } = this.$route.query;
    //     // if (redirect) {
    //     //   return this.$router.replace(redirect);
    //     // }
    //     // return this.$router.replace("/home", () => {});

    //     this.$router.push(`/`, () => {});
    //   }
    //   //*/
    // },
    forgotPasswordClick() {
      this.$router.push(`/forgotpassword`);
    },
    async requestOtpClick() {
      try {
        this.showmessage_callback = null;
        if (this.username.trim()=="" || this.username.trim().length!=10) {
          this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_phoneno}`, 400);
          return;
        }
        this.isShowOverlay = true;
        // var result = await api.isRegister(this.username.toString());
        // if (!result) {
        //   this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_phoneno}`, 400);
        //   return;
        // }
        var result = await api.getOtp(this.username.toString());
        if (result)
          this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.send_otp_success}`, 400);
        else
          this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.send_otp_notsuccess}`, 400);
      } catch (error) {
        this.showMessage(error.toString(), 400);
      }
      finally {
        setTimeout(() => {
          this.isShowOverlay = false;
        }, 1000);
      }
    },
    async doLoginWithPassword() {
      try {
        this.showmessage_callback = null;
        if (this.username?.trim()=="" || this.password?.trim()=="" || this.username?.trim().length!=10) {
          this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_user_or_password}`, 400);
          return;
        }
        this.isShowOverlay = true;
        const response = await api2.login(this.username, this.password);
        if (response) {
          const result = await api.refreshUserInfo();
          // alert(result);
          if (result) {
            // localStorage.setItem(server.TOKEN_KEY, response.data.phone_id);
            this.$store.commit("SET_LOGGED_IN");

            const { redirect } = this.$route.query;
            if (redirect) {
              this.$router.replace(redirect);
            }
            else {
              this.$router.replace("/home", () => {});
            }
            return;
          }
        }
        this.showmessage_callback = this.onShowMessageCallBack;
        this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_user_or_password}`, 400);

        // this.$store.dispatch("doLogout");
        // if (this.$store.state.isLogged) {
        //   let token = localStorage.getItem(server.TOKEN_KEY);
        //   await api.refreshUserInfo(token.toString());

        //   const { redirect } = this.$route.query;
        //   if (redirect) {
        //     this.$router.replace(redirect);
        //   }
        //   else
        //     this.$router.replace("/home", () => {});
        // }
        // else
        //   this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_user_or_password}`, 400);
      } catch (error) {
        this.showMessage(error.response.data.status.toString().concat(' : ').concat(error.response.data.message), 400);
      }
      finally {
        setTimeout(() => {
          this.isShowOverlay = false;
        }, 1000);
      }
    },
    async doLoginWithOtp() {
      try {
        this.showmessage_callback = null;
        // if (this.username.trim()=="" || this.password.trim()=="" || this.username.trim().length!=10) {
        //   this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_user_or_password}`, 400);
        //   return;
        // }
        if (this.username?.trim()=="" || this.username?.trim().length!=10) {
          this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_phoneno}`, 400);
          return;
        }
        if (this.otp?.trim()=="" || this.otp?.trim().length!=6) {
          this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_otp}`, 400);
          return;
        }
        this.isShowOverlay = true;

        // var result = await api.isRegister(this.username.toString());
        // if (!result) {
        //   this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_phoneno}`, 400);
        //   return;
        // }
        // var result = await api.checkOtp(this.username.toString(), this.otp.toString());
        // if (!result) {
        //   this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_otp}`, 400);
        //   return;
        // }

        await this.$store.dispatch({
          type: "doLogin",
          username: this.username.toString(),
          password: this.otp.toString()
          // password: this.password.toString()
        });

        if (this.$store.state.isLogged) {
          // let token = this.$CryptoJS.AES.encrypt(this.username.toString(), server.TOKEN_PASSWORD).toString();
          // // localStorage.setItem(server.USER_NAME, token);
          // // localStorage.setItem(server.TOKEN_KEY, this.remember ? token : "");
          // localStorage.setItem(server.TOKEN_KEY, token);
          // this.gotoHomePage();
          // let token = localStorage.getItem(server.TOKEN_KEY);
          await api.refreshUserInfo();

          const { redirect } = this.$route.query;
          if (redirect) {
            this.$router.replace(redirect);
          }
          else
            this.$router.replace("/home", () => {});
        }
        else
          this.showMessage(`${this.$i18n.getLocaleMessage(this.$i18n.locale).message.invalid_user_or_password}`, 400);
      } catch (error) {
        this.showMessage(error.toString(), 400);
      }
      finally {
        setTimeout(() => {
          this.isShowOverlay = false;
        }, 1000);
      }
    },
    async loginClick() {
      try {
        if (this.login_type == 1)
          await this.doLoginWithOtp()
        else
          await this.doLoginWithPassword();
      } catch (error) {
        this.showMessage(error.toString(), 400);
      }
    }
  },
};
</script>

<style scoped>
.text_input {
  background-color: #FAFAFA;
  color: #000000
}
.black--text /deep/ label {
  font-size: x-small;
  color: #ffffff;
}
.link--text {
  font-size: x-small;
  color: #FFFFFF;
  position: relative;
}
.inputNumber >>> input[type='number'] {
  -moz-appearance:textfield;
}
.inputNumber >>> input::-webkit-outer-spin-button,
.inputNumber >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>